import { render, staticRenderFns } from "./BlogPostsDate.vue?vue&type=template&id=252ccd99&"
import script from "./BlogPostsDate.vue?vue&type=script&lang=js&"
export * from "./BlogPostsDate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports